import script from "./contactVue.vue?vue&type=script&setup=true&lang=js"
export * from "./contactVue.vue?vue&type=script&setup=true&lang=js"

import "./contactVue.vue?vue&type=style&index=0&id=448be563&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448be563"]])

export default __exports__